import React from "react";

import * as S from "./styles";

export const Home: React.FC = () => {
  return (
    <S.Container>
      <S.Content className="left">
        <S.Wrapper>
          <S.SubTitle
            className="wow animate__animated animate__fadeIn"
            data-wow-duration="1s"
          >
            o triunfo do
          </S.SubTitle>
          <S.Title
            className="wow animate__animated animate__fadeIn"
            data-wow-duration="1s"
            data-wow-delay="300ms"
          >
            Design
          </S.Title>
          <S.Text
            className="wow animate__animated animate__fadeIn"
            data-wow-duration="1s"
            data-wow-delay="400ms"
          >
            <p>
              Criada para proteger os pés do homem da caatinga, a xô boi se
              reinventa e reafirma seu desenho ancestral no caminhar do
              brasileiro. Se design consiste em conectar forma e função, essa
              sandália pode ser considerada uma campeã.
            </p>
          </S.Text>
          <S.Credit
            className="wow animate__animated animate__fadeIn"
            data-wow-duration="1s"
            data-wow-delay="500ms"
          >
            Por Elexsandra Morone
          </S.Credit>
          <S.ScrollInfo
            className="wow animate__animated animate__fadeIn"
            data-wow-duration="1s"
            data-wow-delay="600ms"
          >
            <S.IconChevron /> Role para avançar
          </S.ScrollInfo>
        </S.Wrapper>
      </S.Content>
      <S.Content
        className="wow animate__animated animate__fadeIn right"
        data-wow-duration="1s"
        data-wow-delay="700ms"
      >
        <S.PhotoWrapper>
          <S.PhotoLegend>Ilustração: Mariana Baptista</S.PhotoLegend>
          <S.Photo1
            className="wow animate__animated animate__fadeIn"
            data-wow-duration="1s"
            data-wow-delay="300ms"
          />
        </S.PhotoWrapper>
        <S.PhotoLegendMobile>Ilustração: Mariana Baptista</S.PhotoLegendMobile>
      </S.Content>
    </S.Container>
  );
};
